import {observable, computed, action, map} from 'mobx';
import m from 'moment';
import Day from './Day';

const LUNCHBREAK_LENGTH = 1000 * 60 * 30; // 30 minutes
const MAX_WORKDAY_LENGTH = 1000 * 60 * 60 * 18; // 18 hours
const MAX_WITHOUT_LUNCH = 1000 * 60 * 60 * 8; // 8 hours

class Person {
  @observable firstName = null;
  @observable lastName = null;
  @observable id = null;
  @observable key = null;
  @observable isOpen = false;
  store = null;

  constructor(id, person, store) {
    this.store = store;
    this.id = id;
    this.firstName = person.firstName;
    this.lastName = person.lastName;
    this.key = person.key;
  }

  @computed get events() {
    const events = [];
    this.store.events.forEach(event => {
      if (this.id === event.personId) {
        events.push(event);
      }
    });
    // return array sorted by time
    return events.sort((event1, event2) => event1.time - event2.time);
  }

  @computed get fullName() {
    return `${this.firstName} ${this.lastName}`
  }

  @computed get eventsByDay() {
    const days = [];
    this.events.forEach(event => {
      const time = m(event.time).startOf('day').valueOf();
      let day = days.find(day => day.time === time);
      if (!day) {
        day = new Day(time);
        days.push(day);
      }
      day.addEvent(event);
    });
    this.verifyDays(days);
    return days;
  }

  @computed get totalWorkTime() {
    return this.eventsByDay.reduce((acc, day) => acc + day.totalWorkTime, 0);
  }

  @action setOpen = (open) => {
    this.isOpen = open;
  };

  @action toggleOpen = () => {
    this.isOpen = !this.isOpen;
  };

  // Checks if the events in a day make sense
  verifyDays = days => {
    for (let i = 0; i < days.length; i++) {
      const day = days[i];
      day.totalWorkTime = 0;
      const nextDay = days[i + 1];

      let inEvent = {};
      let prevEvent = {};
      for (let j = 0; j < day.events.length; j++) {
        const event = day.events[j];

        if (event.event === 'in') {
          inEvent = event;

          if (j !== 0 && prevEvent.event !== 'out') day.faulty = true;

          // if the last event of the day was an in, check the first event of the next day
          if (j === day.events.length - 1) {
            if (nextDay) {
              const nextEvent = nextDay.events[0];
              if (nextEvent && nextEvent.event === 'out') {
                const workTime = this.calcWorkTime(inEvent, nextEvent, day);
                if (workTime) {
                  // this out should be in this day, move the event here
                  day.addEvent(nextEvent);
                  nextDay.removeEventAt(0);
                  prevEvent = event;
                  continue;
                }
              }
            }

            // if the day of the last in event has not ended, dont mark as faulty
            if (m(event.time).isSame(m(), 'day')) {
              const workTime = this.calcWorkTime(inEvent, {time: Date.now()}, day);
              workTime ? day.totalWorkTime += workTime : day.faulty = true;
              continue;
            }

            day.faulty = true;
          }
        }

        if (event.event === 'out') {
          if (prevEvent.event !== 'in') {
            day.faulty = true;
          } else {
            const workTime = this.calcWorkTime(inEvent, event, day);
            workTime ? day.totalWorkTime += workTime : day.faulty = true;
          }
        }
        prevEvent = event;
      }
    }
  };

  calcWorkTime = (inEvent, outEvent, day) => {
    if (!inEvent || !outEvent) return false;
    const workTime = outEvent.time - inEvent.time;

    // everything is OK, add to totalWorkTime
    if (workTime < MAX_WITHOUT_LUNCH) return workTime;

    // probably forgot lunch, deduct LUNCHBREAK
    if (workTime < MAX_WORKDAY_LENGTH) {
      day.autoLunch = true;
      return workTime - LUNCHBREAK_LENGTH;
    }

    // time difference too long, dont add time, set day faulty
    console.log('workTime too long', workTime, m.duration(workTime).asHours(), m(outEvent.time).format('LL'));
    return false;
  };

  eventsByStint = events => {
    const stints = [];
    const stint = {in: {}, out: {}, length: 0};
    let lastStint = stint;
    events.forEach(event => {
      if (event.event === 'in') {
        lastStint = {...stint, in: event};
        stints.push(lastStint);
      } else if (event.event === 'out') {
        if (lastStint.in.event) {
          lastStint.out = event;
          lastStint.length = lastStint.out.time - lastStint.in.time;
        } else {
          stints.push({...stint, out: event});
        }
        lastStint = stint;
      }
    });
    return stints;
  }
}

export default Person;


// WEBPACK FOOTER //
// ./src/views/Beeper/Person.js